/* eslint-disable max-len */
export default {
    menu: {
        pause: 'Пауза симуляции',
        switchAirport: 'Сменить аэропорт',
        fixesRunways: 'Точки и ВПП',
        sidDisplay: 'Отображение SID',
        starDisplay: 'Отображение STAR',
        airspaceDepiction: 'Границы ВП',
        restrictedAreas: 'Запретные зоны',
        terrain: 'Рельеф',
        videoMaps: 'Видеокарты',
        settings: 'Настройки',
        speech: 'Озвучка',
        traffic: 'Трафик',
        airportGuide: 'Справка по аэропорту',
        commands: 'Команды',
        tutorial: 'Обучение',
        score: 'Счёт',
        timeWarp2: 'Ускорение x2',
        timeWarp5: 'Ускорение x5',
        timeWarp1: 'Обычная скорость x1'
    },
    dialog: {
        settings: 'Настройки',
        traffic: 'Интенсивность трафика',
        videoMaps: 'Видеокарты',
        selectAirport: 'Выбор аэропорта',
        searchAirports: 'поиск аэропортов'
    },
    command: {
        aircraftPlaceholder: 'команда для ВС',
        scopePlaceholder: 'команда сектора'
    },
    autocomplete: {
        legend: 'Обозначения: <b>синоним</b> | <u>аргумент</u> | <i>необязательно</i>',
        navigate: '[↑/↓] навигация',
        select: '[tab] выбрать',
        commit: '[tab] применить',
        revert: '[esc] назад',
        cancel: '[esc] отмена',
        inputCommand: 'поиск команд',
        inputParam: 'ввод аргументов'
    },
    tutorial: {
        previousStep: 'Предыдущий шаг',
        nextStep: 'Следующий шаг',
        loadError: 'Не удалось загрузить обучение: {error}'
    },
    traffic: {
        windDirection: 'направление ветра',
        windSpeed: 'скорость ветра',
        default: 'По умолчанию',
        restart: 'Перезапуск',
        categories: {
            arrival: 'прилёты',
            departure: 'вылеты',
            overflight: 'транзит'
        }
    },
    settings: {
        options: {
            language: {
                description: 'Язык интерфейса',
                options: {
                    en: 'English',
                    ru: 'Русский'
                }
            },
            towerController: {
                description: 'Управление вышкой (экспериментально)',
                options: {
                    SYSTEM: 'Автоматически',
                    USER: 'Вручную'
                }
            },
            controlMethod: {
                description: 'Способ управления',
                options: {
                    classic: 'Классический',
                    arrows: 'Стрелки'
                }
            },
            drawIlsDistanceSeparator: {
                description: 'Индикатор дистанции на ILS',
                options: {
                    'from-theme': 'Из темы',
                    yes: 'Да',
                    no: 'Нет'
                }
            },
            ptlLengths: {
                description: 'Шаг PTL (линия курса), в минутах',
                options: {
                    '0.5-1-1.5-2-2.5-3-3.5-4-4.5-5-5.5-6-6.5-7-7.5-8': '0.5 x n ... 8',
                    '1-2-3-4-5-6-7-8': '1.0 x n ... 8',
                    '1-2-4-6-8-10-12-14-16': '1-2-4-6-8-10-12-14-16',
                    '0.5-1-2-4-8': '0.5-1-2-4-8',
                    '1-2-4-8': '1-2-4-8'
                }
            },
            drawProjectedPaths: {
                description: 'Маршрут ВС на экране',
                options: {
                    always: 'Всегда',
                    selected: 'Выбранное ВС',
                    never: 'Никогда'
                }
            },
            softCeiling: {
                description: 'Выход из зоны набором высоты',
                options: {
                    yes: 'Да',
                    no: 'Нет'
                }
            },
            mouseClickDrag: {
                description: 'Кнопка перемещения карты',
                options: {
                    left: 'Левая кнопка',
                    right: 'Правая кнопка'
                }
            },
            rangeRings: {
                description: 'Дальномерные кольца',
                options: {
                    default: 'По умолчанию',
                    off: 'Выкл.',
                    1: '1 nm',
                    2: '2 nm',
                    5: '5 nm',
                    10: '10 nm',
                    15: '15 nm',
                    20: '20 nm'
                }
            },
            measureToolPath: {
                description: 'Стиль линии измерения',
                options: {
                    0: 'Только прямые',
                    1: 'Дуга до точки, затем прямая',
                    2: 'Все линии дугами'
                }
            },
            chatLogDuration: {
                description: 'Время отображения readback'
            }
        }
    },
    quickCommands: {
        ils: 'Заход ILS',
        dvs: 'Снижение по STAR',
        cvs: 'Набор по SID',
        taxi: 'Руление',
        caf: 'По плану',
        takeoff: 'Взлёт',
        noSelection: 'ВС не выбрано',
        notUnderstood: 'Команда не распознана'
    },
    commandsReference: {
        title: 'Команды',
        intro: 'Команды для ВС вводятся с позывным в начале. Несколько команд можно передать одной строкой.',
        scopeHint: 'Клавиша ` (ё) переключает режим команд сектора.',
        callsign: 'ПОЗЫВНОЙ',
        sections: {
            departure: 'Вылет',
            arrival: 'Прилёт',
            routing: 'Маршрут',
            control: 'Управление',
            query: 'Запросы',
            system: 'Система',
            scope: 'Сектор'
        },
        items: {
            caf: {
                name: 'По плану (CAF)',
                desc: 'Разрешает полёт по поданному маршруту и SID.'
            },
            cvs: {
                name: 'Набор по SID',
                desc: 'Разрешает набор высоты по ограничениям SID.'
            },
            takeoff: {
                name: 'Взлёт',
                desc: 'Разрешает взлёт.'
            },
            taxi: {
                name: 'Руление / ожидание',
                desc: 'Разрешает руление или ожидание.'
            },
            expectRunway: {
                name: 'Ожидай ВПП',
                desc: 'Сообщает ожидаемую ВПП прилёта.'
            },
            dvs: {
                name: 'Снижение по STAR',
                desc: 'Разрешает снижение по ограничениям STAR.'
            },
            ils: {
                name: 'Заход ILS',
                desc: 'Разрешает заход по ILS на указанную ВПП.'
            },
            direct: {
                name: 'Прямо на точку',
                desc: 'Разрешает полёт напрямую на точку.'
            },
            hold: {
                name: 'Ожидание',
                desc: 'Вводит ожидание на точке.'
            },
            exitHold: {
                name: 'Выход из ожидания',
                desc: 'Отменяет ожидание и продолжает маршрут.'
            },
            route: {
                name: 'Маршрут',
                desc: 'Добавляет точку в маршрут.'
            },
            reroute: {
                name: 'Смена маршрута',
                desc: 'Заменяет маршрут новым.'
            },
            sid: {
                name: 'SID',
                desc: 'Назначает или меняет процедуру вылета.'
            },
            star: {
                name: 'STAR',
                desc: 'Назначает или меняет процедуру прилёта.'
            },
            altitude: {
                name: 'Высота',
                desc: 'Набор, снижение или эшелон (в сотнях футов).'
            },
            fph: {
                name: 'Курс без изменений',
                desc: 'Сохранять текущий курс.'
            },
            heading: {
                name: 'Курс',
                desc: 'Поворот влево или вправо на заданный курс; «fh» задаёт курс с поворотом кратчайшим путём.'
            },
            speed: {
                name: 'Скорость',
                desc: 'Увеличить или уменьшить скорость до указанного значения в узлах.'
            },
            cross: {
                name: 'Прохождение точки',
                desc: 'Пройти точку на указанной высоте и/или скорости.'
            },
            sayAltitude: {
                name: 'Доложи высоту',
                desc: 'Запрос текущей высоты.'
            },
            sayAssignedAltitude: {
                name: 'Доложи назначенную высоту',
                desc: 'Запрос назначенной высоты.'
            },
            sayHeading: {
                name: 'Доложи курс',
                desc: 'Запрос текущего курса.'
            },
            sayAssignedHeading: {
                name: 'Доложи назначенный курс',
                desc: 'Запрос назначенного курса.'
            },
            saySpeed: {
                name: 'Доложи скорость',
                desc: 'Запрос текущей скорости.'
            },
            sayAssignedSpeed: {
                name: 'Доложи назначенную скорость',
                desc: 'Запрос назначенной скорости.'
            },
            airport: {
                name: 'Смена аэропорта',
                desc: 'Загружает другой аэропорт.'
            },
            pause: {
                name: 'Пауза',
                desc: 'Ставит симуляцию на паузу или снимает с паузы.'
            },
            timewarp: {
                name: 'Ускорение',
                desc: 'Меняет скорость симуляции.'
            },
            tutorial: {
                name: 'Обучение',
                desc: 'Открывает обучение.'
            },
            scratchpad: {
                name: 'Скретчпад',
                desc: 'Задаёт текст на блоке данных.'
            },
            halo: {
                name: 'Ореол',
                desc: 'Включает или выключает ореол вокруг цели.'
            },
            moveDataBlock: {
                name: 'Сдвиг блока данных',
                desc: 'Перемещает линию и блок данных (направление — цифры numpad).'
            }
        }
    }
};
